<template>
  <div class="container">
    <!--操作-->
    <el-button type="primary" plain size="small" round @click="handleAdd">新增设备</el-button>
    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--列表-->
    <el-table v-loading="loading" :data="tableData" stripe border style="width: 100%">
      <el-table-column border label="设备名称" prop="device_name"></el-table-column>
      <el-table-column border label="设备编号" prop="device_id"></el-table-column>
      <el-table-column border label="校准有效期" prop="calibrate_date"></el-table-column>
      <el-table-column v-if="is_admin" border label="操作" min-width="120" fixed="right">
        <template v-slot="scope">
          <el-button type="primary" plain size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" plain size="mini" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="新增设备" :visible.sync="addModel.addShow" width="700px">
      <el-form ref="addForm" :model="addModel" label-width="120px" size="small">
        <el-form-item label="设备名称">
          <el-input v-model="addModel.device_name"></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="addModel.device_id"></el-input>
        </el-form-item>
        <el-form-item label="校准有效期">
          <el-input v-model="addModel.calibrate_date"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑设备" :visible.sync="editModel.editShow" width="500px">
      <el-form ref="editForm" :model="editModel" label-width="120px" size="small">
        <el-form-item label="设备名称">
          <el-input v-model="editModel.device_name"></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="editModel.device_id"></el-input>
        </el-form-item>
        <el-form-item label="校准有效期">
          <el-input v-model="editModel.calibrate_date"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">编辑</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Vue from "vue";

export default {
  data() {
    return {
      fileList: [],
      loading: false,
      currentConfig: {},
      tableData: [],
      is_admin: false,
      query: { device_name: "" },
      pagination: { current_page: 1, total: 1, per_page: 10, },
      searchConfig: [
        { key: "device_name", label: "设备名称", type: "input" },
      ],
      addModel: {
        addShow: false,
        device_id: '',
        device_name: '',
        calibrate_date: '',
      },
      editModel: {
        editShow: false,
        device_id: '',
        device_name: '',
        calibrate_date: '',
      }
    };
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    //初始化新增对话框
    initModel(modelType) {
      if (modelType === 'add') {
        this.addModel.addShow = false
        this.addModel.device_id = ''
        this.addModel.device_name = ''
        this.addModel.calibrate_date = ''
      } else if (modelType === 'edit') {
        this.editModel.editShow = false
        this.editModel.device_id = ''
        this.editModel.device_name = ''
        this.editModel.calibrate_date = ''
      }
    },
    //新增
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      await this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          try {
            let params = {
              device_id: this.addModel.device_id,
              device_name: this.addModel.device_name,
              calibrate_date: this.addModel.calibrate_date,
            }
            await this.$Api.post('device', params)
            this.$message.success('新增成功')
            this.initModel('add')
            await this.getList()
          } catch (e) {
            this.$message.error(e.errormsg)
          }
        } else {
          this.$message.error("表单输入有误，请检查")
        }
      });

    },
    onAddClose() {
      this.initModel('add')
    },
    //编辑
    handleEdit(row) {
      this.editModel.editShow = true
      this.editModel.id = row.id
      this.editModel.device_name = row.device_name
      this.editModel.device_id = row.device_id
      this.editModel.calibrate_date = row.calibrate_date
    },
    async onEdit() {
      try {
        let params = {
          id: this.editModel.id,
          device_name: this.editModel.device_name,
          device_id: this.editModel.device_id,
          calibrate_date: this.editModel.calibrate_date,
        }
        await this.$Api.post('device_update', params)
        this.$message.success('编辑成功')
        this.initModel('edit')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.initModel('edit')
    },
    //删除
    handleDel(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
        async () => {
          try {
            let params = {
              id: row.id
            }
            await this.$Api.post('device_del', params)
            this.$message.success('删除成功')
            await this.getList()
          } catch (e) {
            this.$message.error(e.errormsg)
          }
        }
      )
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        project_code: "",
        project_name: "",
        status_id: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("device", { params: params });
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    if (Vue.$Config.userinfo.employee_id === 1) {
      this.is_admin = true
    }
    this.getList();
  },
};
</script>